<template>
  <BaseAutoCompleteWithSingleSelectedItem
    v-model="modelValue"
    :label="props.label"
    itemName="name"
    :items="items"
    :operation-offices="operationOffices"
    :error-messages="errorMessages"
    :initialItemId="props.initialItemId"
    :selectFirstIfOnlyOne="props.selectFirstIfOnlyOne"
    :readonly="props.readonly"
    :disabled="props.disabled"
  />
</template>
<script setup lang="ts">
import BaseAutoCompleteWithSingleSelectedItem from '@/components/AutoCompletes/BaseAutoCompleteWithSingleSelectedItem.vue';
import autocompleteDepartmentRequest from "@/types/requests/autocompleteDepartment"
import getOperationOffice from '@/types/responses/getOperationOffice';
import getDepartmentResponse from '@/types/responses/getDepartment';
import { onMounted, ref, computed } from 'vue';
import Api from '@/services/api/ApiServiceFabrick';
import i18n from '@/lang/i18n'

const props = withDefaults(
  defineProps<{
    modelValue: getDepartmentResponse | undefined;
    operationOffices?: getOperationOffice[];
    errorMessages?: string[];
    isUnaffiliated?: boolean
    initialItemId?: number
    requstParams?: autocompleteDepartmentRequest | undefined
    label?: string
    selectFirstIfOnlyOne: boolean
    readonly?: boolean
    disabled?: boolean
  }>(),
  {
    label: i18n.global.t('pages.common.autocomplete.department'),
    selectFirstIfOnlyOne: false,
    disabled: false,
  }
);



const emit = defineEmits(['update:modelValue']);

const items = ref<getDepartmentResponse[]>([]);

onMounted(() => {
  Api()
    .autoCompleteDepartments(props.requstParams)
    .then((data) => {
      items.value = data;
      if (props.isUnaffiliated) addUnaffiliatedColumn()
    });
});

const modelValue = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emit("update:modelValue", value);
  },
});

function addUnaffiliatedColumn() {
  items.value.unshift({
    name: "所属なし",
    operationOfficeId: null,
    id: null
  });
}
</script>
